import { axios } from '@Root/API'

export const edit = payload => {
  return axios.post('current-reference-years', payload)
}
